/* global window, document */
if (! window._babelPolyfill) {
  require('@babel/polyfill');
}

import React from 'react';
import ReactDOM from 'react-dom';
import Admin from './containers/Admin.jsx';
import App from '../src/App';

document.addEventListener('DOMContentLoaded', function() {
  const el = document.getElementById('amzwatcher-admin');
  const apikey = el.attributes['data-api-key'].value;
  const failedFetchBackend = el.attributes['data-failed-fetch'].value === '1' ? true : false;
  // const apikey = null;
  // const apikey = 5a4bfafb-1a0b-4df2-b93f-f936eafc3521 - timber mastery
  // dc5b984d-66f9-4e2e-92da-2633203217bd - dev site
  // ReactDOM.render(<App apikey={apikey} failedFetchBackend={failedFetchBackend} />, el);
  ReactDOM.render(<App apikey={apikey} failedFetchBackend={failedFetchBackend} wpObject={window.wpr_object} />, el);
});
